export class LoggedInUserData {

    PatientID: string;

    UserName: string;

	dob: string;

	mobile: string;

	Email: string;

	age: number;

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/UserProfile/LoggedInUserData.ts